import { css } from 'styled-components';
import { P3 } from '../Typo';

export const tooltip = css`
  .tooltip {
    padding: 8px 16px;
    border-radius: 4px;
    border: solid 1px ${(props) => props.theme.colors.grey300};
    .innerBox {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0px;
      }
      .title {
        ${P3};
        margin-right: 8px;
        color: ${(props) => props.theme.colors.grey500};
      }
      .value {
        ${P3};
        margin-right: 4px;
        color: ${(props) => props.theme.colors.grey700};
      }
      .rate {
        ${P3};
        color: ${(props) => props.theme.colors.grey500};
      }
    }
  }
`;

export { tooltip as default };
